import React from "react"
import cx from "classnames"
import Icon from "@kit/design/icon"

const rowBase = "list-none border-b py-4"

function ProcessingRow({ message, progress }) {
  const percent =
    progress?.total > 0
      ? Math.round((progress.current / progress.total) * 100)
      : 0

  return (
    <li className={rowBase}>
      <p className="text-sm text-gray-700 mb-2">{message}</p>
      <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-green-400 transition-[width] duration-300 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
    </li>
  )
}

function ActionRow({ message, action, status }) {
  const isFailed = status === "failed" || status === "aborted"

  return (
    <li className={cx(rowBase, "flex items-center justify-between")}>
      <p className={`text-sm ${isFailed ? "text-red-700" : "text-gray-700"}`}>
        {message}
      </p>
      {action?.type === "download" && action.path && (
        <a
          href={action.path}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-4 flex shrink-0 items-center gap-1.5 rounded-lg px-2 py-1 text-sm font-semibold text-gray-700 hover:bg-gray-100 hover:no-underline"
        >
          <Icon name="download" aria-hidden />
          Download
        </a>
      )}
    </li>
  )
}

function SummaryRow({ message, status }) {
  const isFailed = status === "failed" || status === "aborted"

  return (
    <li className={rowBase}>
      <p className={`text-sm ${isFailed ? "text-red-700" : "text-gray-700"}`}>
        {message}
      </p>
    </li>
  )
}

const rowByFormat = {
  processing: ProcessingRow,
  action: ActionRow,
  summary: SummaryRow
}

export function NotificationRow({ format, message, progress, action, status }) {
  const Row = rowByFormat[format] ?? SummaryRow
  return (
    <Row
      message={message}
      progress={progress}
      action={action}
      status={status}
    />
  )
}
